import { CandidateAnswers } from '@pflegia/types/api/candidate/candidate-for-prioritization';

export const parseCandidateAnswers = (answers?: string): CandidateAnswers => {
  try {
    return JSON.parse(answers ?? '{}') as CandidateAnswers;
  } catch {
    return {} as CandidateAnswers;
  }
};
